module.exports = __webpack_public_path__ + "assets/e198c9ac47df22da787b89da3fd6a6ff.woff";